import styled from 'styled-components'

export const Container = styled.div`
  position: relative;
  width: 100%;

  .button {
    width: 115px;
    height: 40px;

    display: flex;
    gap: 3px;
    justify-content: center;
    align-items: center;

    font-family: 'Inter';
    font-weight: 500;
    font-size: 14px;
    color: ${({ theme }) => theme.zds.colors.neutral1000};

    svg {
      fill: ${({ theme }) => theme.zds.colors.neutral1000};
      width: 10px;
      height: 10px;
    }
  }
`
